import { createElement } from '../../../utils/utils';
import css from './button.scss';
export const Button = _ref => {
  let {
    text,
    theme,
    onClick,
    className,
    secondary,
    dataHook
  } = _ref;
  const element = createElement({
    tagName: 'button',
    dataHook
  });
  element.className = (className || '') + " " + css.button + " " + (theme && css[theme] || '') + " " + (secondary ? css.secondary : '');
  element.onclick = onClick;
  element.innerText = text;
  return element;
};
//# sourceMappingURL=button.js.map